// @ts-nocheck

import { onMounted, onDeactivated, ref, Ref } from 'vue'

// The observer fires on ANY size change of `scrollviewContent`, which
// includes non-append changes like a checkbox column appearing when
// entering the move-items select mode. `paused` lets the caller
// suspend the auto-scroll while such an unrelated change is in
// flight — pass a Ref that's `true` for the duration.
export function useBottomScroll(
  scrollview: Ref<null | unknown>,
  scrollviewContent: Ref<null | unknown>,
  paused?: Ref<boolean>,
) {
  const observer = ref(null)

  const scrollToBottom = () => {
    if (!scrollview.value) return

    if (scrollview.value?.$el.tagName === 'ION-CONTENT') {
      return scrollview.value?.$el.scrollToBottom(300)
    }

    return scrollview.value?.$el.scroll({
      top: scrollview.value?.$el.scrollHeight,
      // behavior: 'smooth'
    })
  }

  onMounted(() => {
    if (!scrollview.value || !scrollviewContent.value?.$el) return

    observer.value = new ResizeObserver((value) => {
      if (paused?.value) return

      return scrollToBottom()
    })

    if (!observer.value) return

    observer.value.observe(scrollviewContent.value.$el)
  })

  onDeactivated(() => {
    if (scrollviewContent.value?.$el) {
      observer.value.unobserve(el)
    } else {
      observer.value.disconnect()
    }
  })
}
